export default class SimpleComponentRegistery
{
    static initialize()
    {
        SimpleComponentRegistery.types = {};
        SimpleComponentRegistery.entries = {};
    }

    static register(type_name, class_name)
    {
        if (SimpleComponentRegistery.types.hasOwnProperty(type_name))
        {
            throw "ComponentAlreadyRegistered";
        }

        SimpleComponentRegistery.types[type_name] = class_name;
    }

    static get(type_name)
    {
        if (SimpleComponentRegistery.types.hasOwnProperty(type_name))
        {
            return SimpleComponentRegistery.types[type_name];
        }

        return null;
    }

    static has(type_name)
    {
        return SimpleComponentRegistery.get(type_name) !== null;
    }

    static queryDocument()
    {
        SimpleComponentRegistery.queryElement(document);
    }

    static queryElement(element)
    {
        let elements = element.querySelectorAll("*[data-component]");

        if (elements === null)
        {
            return;
        }

        elements = Array.from(elements);

        for (let index in elements)
        {
            let element = elements[index];
            let type = element.dataset.component;

            if (!('componentInitialized' in element.dataset)) {
                if (SimpleComponentRegistery.has(type))
                {
                    let instance = new (SimpleComponentRegistery.get(type))(element);

                    if (! SimpleComponentRegistery.entries.hasOwnProperty(type))
                    {
                        SimpleComponentRegistery.entries[type] = [];
                    }

                    SimpleComponentRegistery.entries[type].push(instance);
                }

                element.dataset.componentInitialized = '';
            }
        }
    }

    static sendMessage(type_name, request_name, message_data)
    {
        if (SimpleComponentRegistery.entries.hasOwnProperty(type_name))
        {
            for (let index in SimpleComponentRegistery.entries[type_name])
            {
                let entry = SimpleComponentRegistery.entries[type_name][index];
                entry.onMessage(request_name, message_data);
            }
        }
    }
}

SimpleComponentRegistery.initialize();